import { lazyVue } from "@/utils";
export default [
    {
        path: '/searchPage',
        name: 'searchPage',
        title: '搜索',
        component: lazyVue('searchPage/index'),
        meta: {
            title: '搜索',
            name: '搜索',
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/searchPage/index.js